// removed by extract-text-webpack-plugin
module.exports = {"sidebar-menu":"_4VQvrEgRAcWfDdfpCwdwN","sidebar-item":"iSEdPFG2WMFej76nS2-mG","context-item":"_3wyxsQAbpcSAvr1eEvIZfO","active-item":"_3bjDJEKemO1Y0VL3OG9g26"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Sidebar/styles/Sidebar.scss
// module id = 1175
// module chunks = 1